import { render, staticRenderFns } from "./AfterDelete.vue?vue&type=template&id=361e7fcd&scoped=true"
import script from "./AfterDelete.vue?vue&type=script&lang=js"
export * from "./AfterDelete.vue?vue&type=script&lang=js"
import style0 from "./AfterDelete.vue?vue&type=style&index=0&id=361e7fcd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e7fcd",
  null
  
)

export default component.exports